<div class="promotion-banner-container {{ component.promotionCode ? 'withCursor' : '' }}" *ngIf="isCode else link" (click)="copyCodeIfExist()">
  <div class="content">
    <span class="text">
      {{ component.text }}
      <span class="code">{{ component.promotionCode }}</span>
    </span>
  </div>
</div>

<ng-template #link>
  <a [customRouterLink]="component.linkTarget" class="promotion-banner-container">
    <div class="content">
    <span class="text">
      {{ component.text }}
      <span class="code">{{ component.promotionCode }}</span>
    </span>
    </div>
  </a>
</ng-template>
